import React, { ChangeEvent, useEffect, useMemo } from 'react';
import {
  // IconButton,
  Paper,
  TableRow,
  TablePagination,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Box,
  Modal,
  Typography,
  Button,
  Checkbox,
  Backdrop,
  CircularProgress,
  // Select,
  // MenuItem,
} from '@mui/material';
// import EditIcon from '@mui/icons-material/Edit';
import PrintIcon from '@mui/icons-material/Print';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { format } from 'date-fns';
import { useAuth } from '../../contexts/auth';
import { ApprovalsTableHead } from './ApprovalsTableHead';
import { CustomTableToolbar } from '../../libs/ui/TableToolbar';
import SearchInput from '../../libs/ui/SearchInput';
import {
  SortDirectionField,
  // UpdateUsersStatusDocument,
  useApprovalsQuery,
  ApprovalSortField,
  useApprovalsLazyQuery,
  PrintApprovalsSelectedDocument,
  ApprovalsDocument,
} from '../../graphql/generated/graphql';
import { ApprovalResponseData } from '../../const/type';
import { headCells } from './const';
import { useApprovalsContext } from '../../contexts/approvals';

const deleteModalStyle = {
  width: 400,
  bgcolor: 'background.paper',
  p: 4,
  boxShadow: 24,
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};


export function ApprovalsContainer() {
  const navigate = useNavigate();
  
  const { me } = useAuth();
  const {
    page,
    rowsPerPage,
    totalCount,
    rows,
    openDeleteModal,
    selected,
    // status,
    searchKey,
    sort,
    sortDirection,
    filters,
    setPage,
    setRowsPerPage,
    setTotalCount,
    setRows,
    setOpenDeleteModal,
    setSelected,
    // setStatus,
    setSearchKey,
    setSort,
    setSortDirection,
    setFilters
  } = useApprovalsContext();


  useEffect(() => {
    document.title = 'Approvals';
    return () => { document.title = 'The 1687 Foundation - Christian Literature Offering Hope Encouragement' };
  }, []);

  const [printApplicationsMutation] = useMutation(PrintApprovalsSelectedDocument, {
    refetchQueries: [
      {
        query: ApprovalsDocument,
        variables: { page: page + 1, pageSize: rowsPerPage, search: searchKey, sort, sortDirection },
      },
    ],
  });

  // const [updateUsersStatusMutation] = useMutation(UpdateUsersStatusDocument, {
  //   refetchQueries: [
  //     {
  //       query: UsersDocument,
  //       variables: { page: page + 1, pageSize: rowsPerPage, search: searchKey, sort, sortDirection },
  //     },
  //   ],
  // });


  const { data, loading } = useApprovalsQuery({
    variables: {
      page: page + 1,
      pageSize: rowsPerPage,
      search: searchKey,
      sort,
      sortDirection,
      filter: filters,
    },
    fetchPolicy: 'network-only',
  });
  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, { data: usersData }] = useApprovalsLazyQuery({
    variables: {
      page: page + 1,
      pageSize: rowsPerPage,
      search: searchKey,
      sort,
      sortDirection,
      filter: filters,
    },
    fetchPolicy: 'network-only',
  });


  useEffect(() => {
    if (data?.ApprovalUsers.items) {
      setRows(data.ApprovalUsers.items as any);
      setTotalCount(data.ApprovalUsers.total);
    }
  }, [data, filters, setRows, setTotalCount]);

  useEffect(() => {
    if (usersData?.ApprovalUsers.items) {
      // @ts-ignore
      setRows(_rows => {
        usersData.ApprovalUsers.items.forEach((item: any) => {
          const _exist = _rows.find((row: ApprovalResponseData) => row.id === item.id);
          if (!_exist) _rows.push(item);
          if (_exist && _exist !== item) _rows[_rows.indexOf(_exist)] = item;
        });
        return [..._rows];
      });
    }
    if (usersData?.ApprovalUsers) setTotalCount(usersData.ApprovalUsers.total);
  }, [setRows, setTotalCount, usersData]);

  const memoHeadCells = useMemo(() => {
    if (me?.isSuperuser || me?.role?.changeUsersProfile) {
      return headCells;
    } else {
      return headCells.filter((item) => item.id !== 'actions');
    }
  }, [me?.isSuperuser, me?.role?.changeUsersProfile]);


  console.log(memoHeadCells)
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = useMemo(() => {
    return rows.map((v)=> ({...v, uniqueId: `${v.id}_${v.requestId}`, id: v.id}));
  }, [rows]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const selectedRows = useMemo(
    () => visibleRows.filter((r) => selected.includes(r.uniqueId)).map((obj)=> {
      const {uniqueId, "__typename": val, updateTime, ...rest} = obj as any;
      return rest;
    }),
    [selected, visibleRows]
  );
  const printRequest = async () => {
    
    if (!selected.length) return;

    const { data: printResponse } = await printApplicationsMutation({ variables: { approvalsSelected: selectedRows } });
    if (printResponse) setSelected([])
    const base64Data = printResponse?.PrintApprovalsSelected || '';
    const decodedData = atob(base64Data);

    const byteArray = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
      byteArray[i] = decodedData.charCodeAt(i);
    }
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const now = new Date();
    const timestamp = now.toISOString().replace(/[:.]/g, '-');
    const a = document.createElement('a');
    a.href = url;
    a.download = `Approvals_${timestamp}.pdf`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const isSelected = (id: any) => {
    return selected.indexOf(id) !== -1;
  };

  const handleClickRow = (name: any) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected: readonly number[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
  };

  const handleSelectAllClick = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = visibleRows.map((n) => n.uniqueId);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleIndexNavigate = (id: number, type: 'user' | 'request') => {
    if(type === 'user') {
      navigate(`/app/application/${id}`)
    } else {
      navigate(`/app/request/${id}`)
    }
  }

  // const handleSelectedStatus = async (value: string) => {
  //   if (value !== '') {
  //     setStatus(value);
  //     const { data: response} = await updateUsersStatusMutation({
  //       mutation: UpdateUsersStatusDocument,
  //       variables: { input: { ids: selected, status: value } },
  //     });
  //     if (response.UpdateUsersStatus.status) setSelected([])
  //   }
  // }

  const handleResort = (sortKey: ApprovalSortField) => {
    if (sort === sortKey) {
      // @ts-ignore
      setSortDirection(_dic => {
        if (_dic === SortDirectionField.Asc) return SortDirectionField.Desc;
        return SortDirectionField.Asc;
      });
    } else {
      setSort(sortKey ?? ApprovalSortField.id);
      setSortDirection(SortDirectionField.Asc);
    }
    setRows([])
  };

  const returnBgColor = (user: any) => {
    if (user.redFlag) return '#ff000033';
    if (user.yellowFlag) return '#ffff0033';
    return ''
  }
  
  const ToolbarActions = (
    <>
      {/* {selected.length > 0 &&
        <Select size='small' displayEmpty value={status} onChange={event => handleSelectedStatus(event.target.value)}>
          <MenuItem value=''>No Selection</MenuItem>
          <MenuItem value='received'>Received</MenuItem>
          <MenuItem value='approved'>Approved</MenuItem>
          <MenuItem value='closed'>Closed</MenuItem>
        </Select>
      } */}

      <Button sx={{ minWidth: 80, mx: 0.25, padding: '4px 10px', fontSize: 12 }} onClick={printRequest} disabled={selected.length === 0}>
        Print <PrintIcon sx={{ ml: 0.5, fontSize: 18 }} />
      </Button>
    </>
  );

  return (
    <Box width='100%'>
        <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loading}>
            <CircularProgress color="inherit" />
        </Backdrop>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <CustomTableToolbar
          title='Approvals'
          numSelected={selected.length}
          onAdd={() => navigate('./new')}
          disableAction={!me?.isSuperuser && !me?.role?.changeUsersProfile}
          customActionButton
          actions={ToolbarActions}
          showActions
          searchBar={
            <SearchInput
              searchKey={searchKey}
              onSearch={(txt: string) => { setPage(0); setRows([]); setSearchKey(txt) }}
            />
          }
        />
        <TableContainer sx={{ maxHeight: 'calc(100vh - 210px)' }}>
          <Table size='small' sx={{ minWidth: 750}} aria-labelledby='tableTitle'>
            <ApprovalsTableHead
              headCells={memoHeadCells}
              numSelected={selected.length}
              rowCount={visibleRows.length < rowsPerPage ? visibleRows.length : rowsPerPage}
              onSelectAllClick={handleSelectAllClick}
              order={sortDirection === SortDirectionField.Asc ? 'asc' : 'desc'}
              onRequestSort={handleResort}
              orderBy={sort}
              filters={filters}
              setFilters={setFilters}
            />
            <TableBody>
              {visibleRows.map((row) => {
                // const uniqueKey = `${row.id}-${row.requestId}`;
                const isItemSelected = isSelected(row.uniqueId);
                return (
                  <TableRow
                    hover
                    role='checkbox'
                    tabIndex={-1}
                    key={row.uniqueId}
                    sx={{ backgroundColor: returnBgColor(row), cursor: 'pointer' }}
                    onClick={() => handleClickRow(row.uniqueId)}
                  >
                    <TableCell padding='checkbox'>
                      <Checkbox color='primary' checked={isItemSelected} inputProps={{ 'aria-labelledby': row.uniqueId.toString() }} />
                    </TableCell>
                    {/* {(me?.isSuperuser || me?.role?.changeUsersProfile) && (
                      <TableCell width={40} padding='none' align='center'>
                        <IconButton onClick={() => navigate(`./${row.id}`)}>
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                    )} */}
                    <TableCell padding="none" align="center" hidden>
                      {row.uniqueId}
                    </TableCell>
                    <TableCell padding="none" align="center">
                    <Typography
                          onClick={(e) => {
                            e.stopPropagation(); 
                            handleIndexNavigate(row.id, 'user');
                          }}
                          sx={{
                            color: 'primary.main',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                            '&:hover': {
                              textDecoration: 'none',
                            },
                          }}
                      >
                      {row.id}
                    </Typography>
                    </TableCell>
                    
                    <TableCell padding='none' align='center'>{format(new Date(row.createTime), "MM/dd/yyyy hh:mmaaaaa'm'")}</TableCell>
                    <TableCell padding='none' align='center'>{row.acceptedDate ? (format(new Date(row.acceptedDate), "MM/dd/yyyy hh:mmaaaaa'm'") !== '12/31/1969 04:00pm' ? format(new Date(row.acceptedDate), "MM/dd/yyyy hh:mmaaaaa'm'") : '-') : '-'}</TableCell>
                    <TableCell padding='none' align='center'>{row.endDate ? (format(new Date(row.endDate), "MM/dd/yyyy hh:mmaaaaa'm'") !== '12/31/1969 04:00pm' ? format(new Date(row.endDate), "MM/dd/yyyy hh:mmaaaaa'm'") : '-') : '-'}</TableCell>
                    <TableCell align='center'>{row?.ministryCategory}</TableCell>
                    <TableCell align='center'>
                      <Typography
                            onClick={(e) => {
                              e.stopPropagation(); 
                              row.requestId !== 0 && handleIndexNavigate(row.requestId!, 'request');
                            }}
                            sx={row.requestId !== 0 ? {
                              color: 'primary.main',
                              cursor: 'pointer',
                              textDecoration: 'underline',
                              '&:hover': {
                                textDecoration: 'none',
                              },
                            } : undefined}
                        >
                        {row?.requestId === 0 ? '-' : row.requestId}
                      </Typography>
                    </TableCell>
                    <TableCell align='center'>{row.requestStatus}</TableCell>
                    <TableCell padding='none' align='center'>{row.requestTime ? format(new Date(row.requestTime), "MM/dd/yyyy hh:mmaaaaa'm'"): '-'}</TableCell>
                    <TableCell padding='none' align='center'>{row.shippedTime ? (format(new Date(row.shippedTime), "MM/dd/yyyy hh:mmaaaaa'm'") !== '12/31/1969 04:00pm' ? format(new Date(row.shippedTime), "MM/dd/yyyy hh:mmaaaaa'm'") : '-') : '-'}</TableCell>
                    <TableCell align='center'>{row.organization}</TableCell>
                    <TableCell align='center'>{row.firstName}</TableCell>
                    <TableCell align='center'>{row.lastName}</TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 50, 100]}
          component='div'
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      <Modal open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
        <Box sx={deleteModalStyle}>
          <Typography>This user will be removed. Are you sure?</Typography>
          <Box width='100%' mt={2} display='flex' justifyContent='flex-end'>
            <Button variant='outlined' onClick={() => setOpenDeleteModal(false)}>Cancel</Button>
            <Button variant='contained' sx={{ ml: 2 }} onClick={() => setOpenDeleteModal(false)}>OK</Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
